/** Ask the protected API to verify the current session. Never follow an SSO redirect from a passive check. */
export async function landingPath(): Promise<"/admin" | "/app"> {
  try {
    const response = await fetch("/api/admin/me", {
      credentials: "same-origin",
      redirect: "manual",
      cache: "no-store",
      signal: AbortSignal.timeout(5000),
    });
    if (response.ok && response.headers.get("content-type")?.includes("application/json")) {
      const admin: unknown = await response.json();
      if (
        admin &&
        typeof admin === "object" &&
        "role" in admin &&
        (admin.role === "admin" || admin.role === "owner")
      )
        return "/admin";
    }
  } catch {
    // Anonymous, non-admin and unavailable sessions continue through the existing candidate entry.
  }
  return "/app";
}
